import React from 'react';
import styles from '../styles/ProjectSection.module.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';



const TokenSection: React.FC = () => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(walletAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

   const [copied, setCopied] = useState(false);
   const walletAddress = "FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump";
  return (
    <div className={styles.projectSection}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.ecosystemTitle}>The $BAKSO Token</h3>
        <p className={styles.sectionDescription}>
          Learn more about the $BAKSO token
        </p>
      </div>

      {/* Grid Container for 2x2 Layout */}
      <div className={styles.projectGrid}>
        {/* Top Row: Token Info and Social Links */}
        <div className={styles.socialLinksContainer}>
          <div className={styles.infoCard}>
            <h3>$BAKSO Token</h3>
            <div className={styles.tokenDetail}>
              <span className={styles.detailLabel}>Contract Address:</span>
              <span className={styles.detailValue}>FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump </span>
              <button 
                className={styles.copyButton} 
                onClick={copyToClipboard}
                title="Copy to clipboard"
              >
                {copied ? "Copied! ✓" : "Copy"}
              </button>
             
              
            </div>
            <div className={styles.tokenDetail}>
              <span className={styles.detailLabel}>Decimals:</span>
              <span className={styles.detailValue}>6</span>
            </div>
            <div className={styles.tokenDetail}>
              <span className={styles.detailLabel}>Blockchain:</span>
              <span className={styles.detailValue}>Solana</span>
            </div>
            <div className={styles.tokenLinks}>
              <a 
                href="https://solscan.io/token/FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                View on Solscan
              </a>
              <a 
                href="https://jup.ag/swap/SOL-FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                Trade on Jupiter
              </a>
              <a 
                href="https://dexscreener.com/solana/dzcvuojulzcrkxzmhu3bxf54trzepa2vmje3lzmdwyzt" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                DexScreener
              </a>
              <a 
                href="https://coinmarketcap.com/currencies/disney-sumatran-tiger/" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                CoinMarketCap
              </a>
              <a 
                href="https://www.coingecko.com/en/coins/bakso" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                CoinGecko
              </a>
            </div>
          </div>
        </div>

        {/* New Social Links Section */}
        <div className={styles.socialLinksContainer}>
          <div className={styles.infoCard}>
            <h3>Connect With Us</h3>
            <p>
              Join the Bakso community across our various platforms to stay updated 
              on Bakso's adventures and the latest project developments.
            </p>
            <div className={styles.socialLinksGrid}>
              <a 
                href="https://x.com/BaksoOnSolana" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <span className={styles.socialIcon}>𝕏</span>
                <span>Twitter (X)</span>
              </a>
              <a 
                href="https://t.me/baksosolportal" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <span className={styles.socialIcon}>✈️</span>
                <span>Telegram</span>
              </a>
              <a 
                href="https://www.tiktok.com/@bakso_tiger" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <span className={styles.socialIcon}>🎬</span>
                <span>TikTok</span>
              </a>
              <a 
                href="https://www.youtube.com/@BaksoSolana" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <span className={styles.socialIcon}>📺</span>
                <span>YouTube</span>
              </a>
              <a 
                href="https://www.instagram.com/baksoonsolana/" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <span className={styles.socialIcon}>📷</span>
                <span>Instagram</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Row: Conservation Efforts and Social Media Presence */}
        {/*<div className={styles.conservationContainer}>
          <div className={styles.infoCard}>
            <h3>Conservation Efforts</h3>
            <p>
              $BAKSO's primary focus is on Bakso the Sumatran tiger and the Bakso Conservation Fund (BCF). 
              To date, we've donated $5,000 in Solana to the Wildlife Conservation Society, supporting 
              tiger conservation initiatives worldwide.
            </p>
            <div className={styles.cardFooter}>
              <Link to="/conservation" className={styles.infoLink}>
                Learn more about our conservation efforts
              </Link>
            </div>
          </div>
        </div>*/}

        <div className={styles.socialContainer}>
          <div className={styles.infoCard}>
            <h3>Social Media Presence</h3>
            <p>
              We're spreading awareness about Bakso and tiger conservation through our social platforms.
              Our TikTok has achieved remarkable success with multiple videos reaching over 1 million views.
            </p>
            <div className={styles.socialStats}>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>8,326+</span>
                <span className={styles.statLabel}>TikTok Followers</span>
              </div>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>656K+</span>
                <span className={styles.statLabel}>Total Likes</span>
              </div>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>2+</span>
                <span className={styles.statLabel}>Million-View Videos</span>
              </div>
            </div>
            <p className={styles.monetizationNote}>
              All funds earned from monetization are reinvested into the project ecosystem and tiger conservation efforts.
            </p>
            <div className={styles.cardFooter}>
              <a 
                href="https://tiktok.com/@bakso_tiger" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                Visit our TikTok
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>

      
  );
};

export default TokenSection;